<!--
 * @Description: 申请发票
 * @Author:  wang.y
-->
<template>
  <van-popup v-model="modelIndex" position="bottom" round @close="clearForms">
    <div class="container-wrapper">
      <div class="line" @click="modelIndex = false"></div>
      <div class="container-top">
        <Form ref="apply-invoice" :model="invoiceForm" :rules="ruleValidate" v-show="orderItem.invoiceStatus == 0">
          <FormItem :label="'发票金额' | dealLanguage('Amount')" class="lh20">
            <div class="ivu-input-wrapper ivu-input input-font">¥{{orderItem.paymentAmount}}</div>
          </FormItem>
          <FormItem :label="'发票类型' | dealLanguage('Invoice Type')" class="lh20">
            <div class="radio-btns">
              <span class="tag-btn on">{{'增值税电子普通发票' | dealLanguage('VAT electronic general invoice')}}</span>
            </div>
          </FormItem>
          <FormItem :label="'抬头类型' | dealLanguage('Header Type')" class="lh30">
            <div class="radio-btns">
              <span :class="['tag-btn', invoiceForm.headerType == 1 && 'on']" @click="invoiceForm.headerType = 1">{{'个人' | dealLanguage('personal')}}</span>
              <span :class="['tag-btn', invoiceForm.headerType == 2 && 'on']" @click="invoiceForm.headerType = 2">{{'单位' | dealLanguage('company')}}</span>
            </div>
          </FormItem>
          <FormItem prop="header" :label="'发票抬头' | dealLanguage('Invoice Title')">
            <Input type="text" v-model="invoiceForm.header" :placeholder="'请输入发票抬头' | dealLanguage('Please enter the invoice title')"></Input>
          </FormItem>
          <FormItem prop="uniformSocialCreditCode" :label="'单位税号' | dealLanguage('Unit tax number')" v-if="invoiceForm.headerType == 2">
            <Input type="text" v-model="invoiceForm.uniformSocialCreditCode" :placeholder="'请输入单位税号（企业必填）' | dealLanguage('Please enter your company tax number (required for enterprises)')"></Input>
          </FormItem>
          <FormItem prop="email" :label="'电子邮箱' | dealLanguage('Email')">
            <Input type="text" v-model="invoiceForm.email" :placeholder="'请输入电子邮箱' | dealLanguage('Please enter your email address')"></Input>
          </FormItem>
        </Form>
        <div class="info-list" v-show="orderItem.invoiceStatus != 0">
          <div class="info-item">
            <span class="spa1">{{'发票金额' | dealLanguage('Amount')}}</span>
            <span class="spa2">¥{{orderItem.paymentAmount}}</span>
          </div>
          <div class="info-item">
            <span class="spa1">{{'发票类型' | dealLanguage('Invoice Type')}}</span>
            <span class="spa2">{{'增值税电子普通发票' | dealLanguage('VAT electronic general invoice')}}</span>
          </div>
          <div class="info-item">
            <span class="spa1">{{'抬头类型' | dealLanguage('Header Type')}}</span>
            <span v-if="language == 'zh'">{{orderItem.headerType == 1 ? '个人' : '单位'}}</span>
            <span v-if="language == 'en'">{{orderItem.headerType == 1 ? 'personal' : 'company'}}</span>
          </div>
          <div class="info-item">
            <span class="spa1">{{'发票抬头' | dealLanguage('Invoice Title')}}</span>
            <span class="spa2">{{orderItem.header}}</span>
          </div>
          <div class="info-item" v-if="orderItem.headerType == 2 && orderItem.uniformSocialCreditCode">
            <span class="spa1">{{'单位税号' | dealLanguage('Unit tax number')}}</span>
            <span class="spa2">{{orderItem.uniformSocialCreditCode}}</span>
          </div>
          <div class="info-item">
            <span class="spa1">{{'电子邮箱' | dealLanguage('Email')}}</span>
            <span class="spa2">{{orderItem.email}}</span>
          </div>
          <div class="info-item">
            <span class="spa1">{{'发票状态' | dealLanguage('Invoice Status')}}</span>
            <span v-if="language == 'zh'">{{orderItem.invoiceStatus == 1 ? '开票中' : '已开票'}}</span>
            <span v-if="language == 'en'">{{orderItem.invoiceStatus == 1 ? 'Invoicing' : 'Invoiced'}}</span>
          </div>
        </div>
      </div>
      <div class="container-bottom" v-if="orderItem.invoiceStatus == 0">
        <div class="tip" >
          {{'我们将通过电子邮箱向您发送电子版发票，发票信息一经提交，无法修改，请谨慎填写' | dealLanguage('We will send you an electronic invoice via email. Once the invoice information is submitted, it cannot be modified. Please fill it in carefully.')}}
        </div>
        <div class="btns-wrapper">
          <van-button type="warning" block @click="close">{{'取消' | dealLanguage('Cancel')}}</van-button>
          <van-button type="primary" block @click="applyInvoice">{{'提交' | dealLanguage('Submit')}}</van-button>
        </div>
      </div>
      <div class="container-bottom" v-else>
        <div class="tip">
          {{'我们将通过电子邮箱向您发送电子版发票' | dealLanguage('We will send you an electronic invoice via email')}}
        </div>
        <div class="btns-wrapper">
          <van-button type="primary" class="btn1" block @click="close">{{'确认' | dealLanguage('Confirm')}}</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { addinvoice } from '@/service/vbef'
import filter from 'js/filter'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      filter,
      orderItem: {},
      orderIndex: 0,
      modelIndex: false,
      buttonLoading: false,
      invoiceForm: {
        header: '',
        headerType: 1,
        type: 1,
        uniformSocialCreditCode: '',
        email: '',
      },
      ruleValidate: {
        header: [{ required: true, message: filter.dealLanguage('请输入发票抬头', 'Please enter the invoice title'), trigger: 'blur' }],
        email: [
          { required: true, message: filter.dealLanguage('请输入电子邮箱', 'Please enter your email address'), trigger: 'blur' },
          { type: 'email', message: filter.dealLanguage('请填写正确的邮箱', 'Please fill in the correct email address'), trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    clearForms(value) {
      if (value) return
      this.$refs['apply-invoice'].resetFields()
    },
    applyInvoice() {
      this.$refs['apply-invoice'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          this.invoiceForm.orderId = this.orderItem.id
          let res = await addinvoice(this.invoiceForm)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$Message.success(this.language == 'zh' ? '申请成功！' : 'Application successful!')
            this.$emit('success', res.data, this.orderIndex)
            this.modelIndex = false
          } else {
            this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
  },
  created() {},
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/modal-form-m.styl'
</style>
